<template>
  <q-layout view="hHh LpR fFf" >
    <login v-if="!isAuthenticated" />
    <dashboard v-else />
  </q-layout>
</template>

<script>
import Login from './components/login';
import Dashboard from './components/dashboard';
import {ref} from "vue";

export default {
  name: 'App',
  components: {
    Login,
    Dashboard
  },
  data() {
    this.emitter.on("setAuthenticated", () => {
      this.isAuthenticated = true;
      this.$router.push({name: 'main', params: {} });
    })
    return {
      isAuthenticated: ref(false)
    }
  }

}
</script>

<style>

</style>
